import { SelectOption } from '@/components/Form/src/types'
import { systemEnums } from './systemEnums'

const Role: SelectOption[] = [
  {
    label: 'Trainee',
    value: systemEnums.Role.Trainee
  },
  {
    label: 'Fellow',
    value: systemEnums.Role.Fellow
  },
  {
    value: systemEnums.BasicRole.CosSupervisor,
    label: 'COS/Supervisor'
  },
  {
    label: 'System Admin',
    value: systemEnums.Role.SystemAdmin
  },
  {
    label: 'Basic Trainee (BST)',
    value: systemEnums.Role.BasicTrainee
  },
  {
    label: 'Higher Trainee (HOT)',
    value: systemEnums.Role.HigherTrainee
  },
  {
    label: 'General Fellow',
    value: systemEnums.Role.GeneralFellow
  },
  {
    label: 'Trainer',
    value: systemEnums.Role.Trainer
  },
  {
    label: 'COS',
    value: systemEnums.Role.COS
  },
  {
    label: 'Secretary of Board of Examiners',
    value: systemEnums.Role.SecretaryBoardExaminers
  },
  {
    label: 'Chairperson of Board of Examiners',
    value: systemEnums.Role.ChairpersonBoardExaminers
  }
]

const TrainingType: SelectOption[] = [
  {
    label: 'Basic Training',
    value: systemEnums.TrainingType.BasicTraining
  },
  {
    label: 'Higher Training',
    value: systemEnums.TrainingType.HigherTraining
  }
]

const PaymentMethod: SelectOption[] = [
  {
    label: 'Online Payment',
    value: systemEnums.PaymentMethod.Online
  },
  {
    label: 'Cheque',
    value: systemEnums.PaymentMethod.Cheque
  },
  {
    label: 'Bank Transfer',
    value: systemEnums.PaymentMethod.BankTransfer
  }
]

const OptionModeRating1: SelectOption[] = [
  {
    value: systemEnums.RatingValue.zero,
    label: '0'
  },
  {
    value: systemEnums.RatingValue.one,
    label: '1'
  },
  {
    value: systemEnums.RatingValue.two,
    label: '2'
  },
  {
    value: systemEnums.RatingValue.three,
    label: '3'
  },
  {
    value: systemEnums.RatingValue.four,
    label: '4'
  },
  {
    value: systemEnums.RatingValue.five,
    label: '5'
  }
]

const OptionModeRating11: SelectOption[] = [
  {
    value: systemEnums.OptionModeYesNo.Yes,
    label: 'Yes'
  },
  {
    value: systemEnums.OptionModeYesNo.No,
    label: 'No'
  },
  {
    value: systemEnums.OptionModeYesNo.Na,
    label: 'N/A'
  }
]

const OptionModeRating12: SelectOption[] = [
  {
    value: systemEnums.OptionModeYesNo.Yes,
    label: 'Yes'
  },
  {
    value: systemEnums.OptionModeYesNo.No,
    label: 'No'
  }
]

const OptionModeRating21: SelectOption[] = [
  {
    value: systemEnums.RatingValue21.one,
    label: '1'
  },
  {
    value: systemEnums.RatingValue21.tow,
    label: '2'
  },
  {
    value: systemEnums.RatingValue21.three,
    label: '3'
  },
  {
    value: systemEnums.RatingValue21.four,
    label: '4'
  },
  {
    value: systemEnums.RatingValue21.five,
    label: '5'
  },

  {
    value: systemEnums.RatingValue21.six,
    label: '6'
  }
]

const RatingValue31Options: SelectOption[] = [
  {
    label: 'Strongly disagree',
    value: systemEnums.RatingValue31.StronglyDisagree
  },
  {
    label: 'Disagree',
    value: systemEnums.RatingValue31.Disagree
  },
  {
    label: 'Agree',
    value: systemEnums.RatingValue31.Agree
  },
  {
    label: 'Strongly agree',
    value: systemEnums.RatingValue31.StronglyAgree
  }
]

const QuestionaireRating21Options: SelectOption[] = [
  {
    value: systemEnums.QuestionaireRating21.one,
    label: '1'
  },
  {
    value: systemEnums.QuestionaireRating21.two,
    label: '2'
  },
  {
    value: systemEnums.QuestionaireRating21.three,
    label: '3'
  },
  {
    value: systemEnums.QuestionaireRating21.four,
    label: '4'
  },
  {
    value: systemEnums.QuestionaireRating21.five,
    label: '5'
  },
  {
    value: systemEnums.QuestionaireRating21.six,
    label: '6'
  }
]

const QuestionaireRating22Options: SelectOption[] = [
  {
    value: systemEnums.QuestionaireRating22['Strongly disagree'],
    label: 'Strongly disagree'
  },
  {
    value: systemEnums.QuestionaireRating22.Disagree,
    label: 'Disagree'
  },
  {
    value: systemEnums.QuestionaireRating22.Neutral,
    label: 'Neutral'
  },
  {
    value: systemEnums.QuestionaireRating22.Agree,
    label: 'Agree'
  },
  {
    value: systemEnums.QuestionaireRating22['Strongly agree'],
    label: 'Strongly agree'
  }
]

const QuestionaireRating51Options: SelectOption[] = [
  {
    value: systemEnums.QuestionaireRating51['In firm meeting'],
    label: 'In firm meeting'
  },
  {
    value: systemEnums.QuestionaireRating51['During OPD session'],
    label: 'During OPD session'
  },
  {
    value: systemEnums.QuestionaireRating51.Both,
    label: 'Both'
  }
]

const QuestionaireRating61Options: SelectOption[] = [
  {
    value: systemEnums.QuestionaireRating61['Far too few'],
    label: 'Far too few'
  },
  {
    value: systemEnums.QuestionaireRating61['Too few'],
    label: 'Too few'
  },
  {
    value: systemEnums.QuestionaireRating61.Appropriate,
    label: 'Appropriate'
  },
  {
    value: systemEnums.QuestionaireRating61['Too much'],
    label: 'Too much'
  },
  {
    value: systemEnums.QuestionaireRating61['Far too much'],
    label: 'Far too much'
  }
]

export const systemOptions = {
  Role,
  TrainingType,
  PaymentMethod,
  OptionModeRating1,
  OptionModeRating21,
  RatingValue31Options,
  QuestionaireRating21Options,
  QuestionaireRating22Options,
  QuestionaireRating51Options,
  QuestionaireRating61Options,
  OptionModeRating11,
  OptionModeRating12
}
